<template>
  <div class="goBeiH5" ref="goBeiH5">
    <div class="fpgoBei">
      <div class="text">
        <div class="t1">GO呗智慧零售</div>
        <div class="t2">
          GO呗零售解决方案基于传统零售门店，致力推动线上线下一体化，为零售商家搭建线上小程序平台，完成电商平台和实体门店在商业维度上的升级，为商家提供可视化数据、库存、订单、营销、会员等数据信息，助力零售门店商家转型。
        </div>
      </div>
    </div>
    <div class="goBei-ji">
      <div class="box-img">
        <img src="~@/assets/goBei-img.png" class="img" alt="" />
      </div>
    </div>
    <div class="saas">
      <div class="text">
        <div class="t1">Saas产品介绍</div>
        <div class="t2">全场景全渠道SaaS产品，助力企业数字化升级</div>
      </div>
      <div class="swoper-box">
        <swiper :options="swiperOption" ref="mySwiper">
          <swiper-slide>
            <div class="lb">
              <img src="~@/assets/saas1H5.png" class="img" alt="" />
            </div>
          </swiper-slide>
          <swiper-slide>
            <div class="lb">
              <img src="~@/assets/saas2H5.png" class="img" alt="" />
            </div>
          </swiper-slide>
          <swiper-slide>
            <div class="lb">
              <img src="~@/assets/saas3H5.png" class="img" alt="" />
            </div>
          </swiper-slide>
        </swiper>
      </div>
    </div>
    <div class="applets">
      <div class="text">
        <div class="t1">如何帮助传统零售、电商行业转型</div>
        <div class="t2">小程序电商平台，打造商家自己的流量群体</div>
      </div>
      <div class="img-box">
        <img src="~@/assets/applets.png" class="img" alt="" />
      </div>
      <div class="txt">
        移动互联网时代，流量红利掌控了多数商家的利润来源，商家对拥有自有流量、独立电商平台的需求越发猛烈，“去中心化电商”成为商家的新诉求。
      </div>
      <div class="txt txt1">
        小程序带来的便捷用完即走的优势，成为了商家获取流量红利，增加经营收入，成为了当前零售行业的浪潮。
      </div>
    </div>
    <div class="smart-retail">
      <div class="text">
        <div class="t1">智慧零售</div>
        <div class="t2">
          社区+门店+线上+线下，多渠道一体化经营；线上商城、线下门店、社交营销、分销推客、会员管理；
        </div>
      </div>
      <div class="img-box">
        <div class="left">
          <div class="box box1">社交营销</div>
          <div class="box box2">社区团购</div>
          <div class="box box3">多渠道</div>
        </div>
        <div class="right">
          <div class="box box1">创新</div>
          <div class="box box2">大数据</div>
        </div>
      </div>
    </div>
    <div class="advantage">
      <div class="text">go呗为传统零售行业提供的优势</div>
      <div class="img-box">
        <div class="img-item" v-for="item of advantageList" :key="item.title">
          <div class="img-box-advantage">
            <img :src="item.url" class="img" alt="" />
          </div>
          <div class="title">{{ item.title }}</div>
          <div class="txt">{{ item.txt }}</div>
        </div>
      </div>
    </div>
    <div class="program">
      <div class="text">一体化解决方案</div>
      <div class="txt" v-for="item of txtList" :key="item.t1">
        <div class="t1">{{ item.t1 }}</div>
        <div class="t2">{{ item.t2 }}</div>
      </div>
    </div>
    <div class="community">
      <div class="text">为社区模式量身打造 解决不同角色需求</div>
      <div class="div-box div-box1">
        <div class="name name1">社区团购企业</div>
        <div class="text-box">
          <div class="title">整合货源 发展社区</div>
          <div class="txt">
            通过社区系统后台添加和管理社区团长，统一上传商品、管理订单、财务结算。根据具体需求针对不同社区制定不同经营方正，合理配备商品至各个社区团长。
          </div>
        </div>
      </div>
      <div class="div-box div-box2">
        <div class="name name2">团长（合伙人）</div>
        <div class="text-box">
          <div class="title">建立微信群 推广商品</div>
          <div class="txt">
            团长一键分享最新商品、活动微商城链接，供其他用户查看。
            告别传统的手工统计和收单，系统自动提醒下单的居民到货、提货，佣金随时提现，结算更透明。
          </div>
        </div>
      </div>
      <div class="div-box div-box2">
        <div class="name name3">周边居民</div>
        <div class="text-box">
          <div class="title">整合货源 发展社区</div>
          <div class="txt">
            通过社区团购小程序，在小区周边快速传播，因为购物便捷，搭配各种营销活动，吸引周边居民购物，下完单即可退出。
            商品源头直采，价格实惠，多点自提，提高客户稳定性，为商家和消费者带来双赢。
          </div>
        </div>
      </div>
    </div>
    <div class="decorate">
      <div class="text">
        <div class="t1">个性化店铺装饰</div>
        <div class="t2">
          开放的自定义商城装饰，告别传统模式，根据经验销售商品，打造商家专属的特色小程序。
        </div>
      </div>
      <div class="img-box">
        <img src="~@/assets/iPhone13.png" class="img" alt="" />
      </div>
      <div class="txt">各种精美装饰模版提供</div>
      <div class="txt txt1">开放式自定义配置</div>
      <div class="txt">打造品牌专属的个人中心</div>
    </div>
    <div class="marketing">
      <div class="text">
        <div class="t1">数百种营销玩法，应有尽有</div>
        <div class="t2">
          营销不仅仅是一种促销方式，把消费变成一种“游戏，让客户更加热衷。
        </div>
      </div>
      <div class="img-box-list">
        <div class="img-item" v-for="item of marketingList" :key="item.title">
          <div class="img-box">
            <img :src="item.url" class="img" alt="" />
          </div>
          <div class="txt">{{ item.title }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      swiperOption: {
        loop: true,
        slidesPerView: 1.58,
        // loopAdditionalSlides: 6,
        spaceBetween: 10,
        centeredSlides: true,
        autoplay: {
          delay: 5000,
          // stopOnLastSlide: false,
          disableOnInteraction: false,
        },
        // 显示分页
        pagination: {
          el: ".swiper-pagination",
          clickable: true, //允许分页点击跳转
        },
      },
      advantageList: [
        {
          title: "丰富的营销玩法",
          txt: "各种主流营销活动：砍价、拼团、组合套餐、秒杀、特价、积分商城、推客分销等",
          url: require("@/assets/advantage1H5.png"),
        },
        {
          title: "更低的商家成本",
          txt: "线下门店，线上商城多渠道经营，降低商家经营成本，同时解决线上流量问题",
          url: require("@/assets/advantage2H5.png"),
        },
        {
          title: "高效的管理效率",
          txt: "小程序后台、web后台、数据可视化，帮助商家掌握销售情况，提高管理效率",
          url: require("@/assets/advantage3H5.png"),
        },
        {
          title: "专业的零售服务",
          txt: "针对行业线上线下问题进行整合，线上线下一体化，为商家提供更便捷的服务",
          url: require("@/assets/advantage4H5.png"),
        },
      ],
      txtList: [
        {
          t1: "线上商城",
          t2: "小程序+微商城，直营、加盟任你选，打造自己的线上平台",
        },
        {
          t1: "社区门店",
          t2: "线上下单、门店自提、快递配送、送货上门，多渠道经营",
        },
        {
          t1: "营销同步",
          t2: "打破线上线下难题，将营销活动、会员、积分、卡券做到线上线下同步更有推客、分销、拼团、砍价等营销玩法",
        },
        {
          t1: "数据走向分析",
          t2: "商品销售情况、走势分析、各种统计报表、随时掌握一手经营数据帮助商家了解经营销售情况，做出针对性调整",
        },
      ],
      marketingList: [
        {
          title: "广告推送",
          url: require("@/assets/ggtsH5.png"),
        },
        {
          title: "拼团砍价",
          url: require("@/assets/ptkjH5.png"),
        },
        {
          title: "限时特价",
          url: require("@/assets/xstjH5.png"),
        },
        {
          title: "组合套餐",
          url: require("@/assets/zhtcH5.png"),
        },
        {
          title: "优惠券/礼券",
          url: require("@/assets/yhqH5.png"),
        },
        {
          title: "积分商城",
          url: require("@/assets/jfscH5.png"),
        },
        {
          title: "签到抽奖",
          url: require("@/assets/qdcjH5.png"),
        },
        {
          title: "储值余额",
          url: require("@/assets/czyyH5.png"),
        },
        {
          title: "短视频购物",
          url: require("@/assets/dspH5.png"),
        },
        {
          title: "直播带货",
          url: require("@/assets/zbdhH5.png"),
        },
        {
          title: "推客分销",
          url: require("@/assets/tkfxH5.png"),
        },
        {
          title: "会员体系",
          url: require("@/assets/hytxH5.png"),
        },
      ],
    };
  },
  activated() {
    this.$refs.goBeiH5.scrollIntoView();
  },
};
</script>
<style lang="less" scoped>
.goBeiH5 {
  width: 750px;
  .fpgoBei {
    width: 750px;
    height: 681px;
    background: url("~@/assets/goBeiBg.png") no-repeat;
    background-size: 100% 100%;
    padding: 64px 65px;
    .text {
      text-align: center;
      .t1 {
        font-size: 64px;
        line-height: 80px;
        font-weight: 500;
        color: #ffffff;
      }
      .t2 {
        margin: 42px 0;
        font-size: 26px;
        line-height: 40px;
        color: #ffffff;
      }
    }
    .btn {
      width: 212px;
      height: 64px;
      color: #005ce6;
      text-align: center;
      margin: 54px auto 0;
      font-size: 30px;
      line-height: 64px;
      background: #ffffff;
      box-shadow: 8px 8px 20px rgba(55, 99, 170, 0.1);
      border-radius: 6px;
    }
  }
  .goBei-ji {
    width: 750px;
    height: 237px;
    background: #fff;
    position: relative;
    .box-img {
      width: 634px;
      height: 438px;
      position: absolute;
      left: 58px;
      bottom: 60px;
      .img {
        width: 100%;
        height: 100%;
      }
    }
  }
  .saas {
    padding: 64px 32px;
    background: #fff;
    .text {
      text-align: center;
      .t1 {
        font-size: 40px;
        line-height: 48px;
        font-weight: 500;
        color: #292929;
      }
      .t2 {
        margin-top: 28px;
        line-height: 40px;
        margin-top: 24px;
        color: #51565d;
      }
    }
    .swoper-box {
      margin-top: 40px;
      height: 632px;
      .swiper-container {
        position: relative;
        width: 100%;
        height: 632px;
      }
      .swiper-slide {
        text-align: center;
        background: #eee;
        display: flex;
        justify-content: center;
        align-items: center;
        transition: 300ms;
        transform: scale(0.8);
      }
      .swiper-slide-active,
      .swiper-slide-duplicate-active {
        transform: scale(1);
      }

      .lb {
        .img {
          width: 480px;
          height: 632px;
        }
      }
    }
  }
  .applets {
    background: #f8faff;
    padding: 64px 75px;
    .text {
      text-align: center;
      .t1 {
        font-size: 40px;
        line-height: 48px;
        font-weight: 500;
        color: #292929;
      }
      .t2 {
        margin-top: 20px;
        line-height: 40px;
        font-size: 26px;
        color: #51565d;
      }
    }
    .img-box {
      width: 480px;
      height: 408px;
      margin: 40px auto;
      .img {
        width: 100%;
        height: 100%;
      }
    }
    .txt {
      line-height: 40px;
      font-size: 28px;
      color: #51565d;
    }
    .txt1 {
      margin-top: 24px;
    }
  }
  .smart-retail {
    background: #fff;
    padding: 64px 75px;
    .text {
      text-align: center;
      .t1 {
        font-size: 40px;
        line-height: 48px;
        font-weight: 500;
        color: #292929;
      }
      .t2 {
        margin-top: 20px;
        line-height: 40px;
        font-size: 26px;
        color: #51565d;
      }
    }
    .img-box {
      display: flex;
      margin-top: 40px;
      align-items: center;
      .box {
        display: flex;
        align-items: center;
        justify-content: center;
        color: #fff;
      }
      .left {
        display: flex;
        flex-direction: column;
        align-items: flex-end;

        .box1 {
          width: 268px;
          height: 178px;
          background: linear-gradient(66.2deg, #9a5eff 0%, #5b93ff 100%);
          border-radius: 22px 22px 0px 22px;
        }
        .box2 {
          width: 173px;
          height: 110px;
          background: linear-gradient(66.2deg, #783fbb 0%, #f287a6 100%);
          border-radius: 22px 0px 22px 22px;
          margin: 29px 0 24px;
        }
        .box3 {
          width: 193px;
          height: 115px;
          background: linear-gradient(105.57deg, #3241f7 0%, #3dc3fe 100%);
          border-radius: 22px 22px 0px 22px;
        }
      }
      .right {
        display: flex;
        flex-direction: column;
        margin-left: 29px;
        align-items: flex-start;

        .box1 {
          width: 269px;
          height: 160px;
          background: linear-gradient(105.57deg, #1f1f4f 0%, #2b348a 100%);
          border-radius: 22px 22px 22px 0px;
          margin-bottom: 30px;
        }
        .box2 {
          width: 308px;
          height: 193px;
          background: linear-gradient(62.12deg, #f75f60 0%, #f89e64 100%);
          border-radius: 0px 22px 22px 22px;
        }
      }
    }
  }
  .advantage {
    padding: 50px 40px 70px;
    background: #f8faff;
    .text {
      font-size: 40px;
      line-height: 48px;
      font-weight: 500;
      color: #292929;
    }
    .img-box {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      margin-top: 50px;
      .img-item {
        width: 319px;
        height: 440px;
        background: #ffffff;
        box-shadow: 0px 6px 20px rgba(68, 93, 127, 0.1);
        border-radius: 8px;
        padding: 36px 32px;
        display: flex;
        flex-direction: column;
        align-content: center;
        justify-content: center;
        align-items: center;
        margin-bottom: 24px;
        .img-box-advantage {
          width: 100px;
          height: 100px;
          .img {
            width: 100%;
            height: 100%;
          }
        }
        .title {
          margin: 32px 0 16px;
          font-size: 30px;
          font-weight: 500;
        }
        .txt {
          font-size: 28px;
          line-height: 40px;
          color: #51565d;
        }
      }
    }
  }
  .program {
    width: 750px;
    height: 818px;
    background: url("~@/assets/programBg.png") no-repeat;
    background-size: 100% 100%;
    padding: 64px 32px;
    color: #fff;
    .text {
      text-align: center;
      margin-bottom: 40px;
      font-size: 40px;
      line-height: 48px;
      font-weight: 500;
    }
    .txt {
      margin-bottom: 40px;
      .t1 {
        font-size: 36px;
        font-weight: 500;
        line-height: 44px;
      }
      .t2 {
        margin-top: 16px;
        font-size: 26px;
        line-height: 40px;
      }
    }
    .txt:last-child {
      margin-bottom: 0;
    }
  }
  .community {
    width: 750px;
    height: 1530px;
    background: url("~@/assets/communityBg.png") no-repeat;
    background-size: 100% 100%;
    padding: 64px 39px;
    .text {
      width: 360px;
      margin: 0 auto;
      text-align: center;
      font-size: 40px;
      line-height: 48px;
      font-weight: 500;
      color: #292929;
    }
    .div-box {
      width: 670px;
      height: 406px;
      background: rgba(255, 255, 255, 0.38);
      box-shadow: 0px -4px 20px rgba(68, 93, 127, 0.1);
      border-radius: 8px;
      .name {
        width: 670px;
        height: 88px;
        font-weight: 500;
        font-size: 32px;
        line-height: 40px;
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .name1 {
        background: linear-gradient(180deg, #ffb696 0%, #ff7a95 100%);
      }
      .name2 {
        background: linear-gradient(180deg, #1dd5e6 0%, #46aef7 100%);
      }
      .name3 {
        background: linear-gradient(180deg, #72d7cc 0%, #28cfb3 100%);
      }
      .text-box {
        padding: 48px 32px;

        width: 670px;
        height: 318px;
        padding: 48px 32px;

        .title {
          font-weight: 500;
          font-size: 30px;
          line-height: 38px;
          text-align: center;
          color: #292929;
        }
        .txt {
          margin-top: 24px;
          font-size: 26px;
          line-height: 40px;
          text-align: center;
          color: #292929;
        }
      }
    }
    .div-box1 {
      margin-top: 40px;
    }
    .div-box2 {
      margin-top: 24px;
    }
  }
  .decorate {
    padding: 50px 65px;
    background: linear-gradient(
      180deg,
      #f8faff 0%,
      rgba(248, 250, 255, 0) 100%
    );
    .text {
      text-align: center;
      .t1 {
        font-size: 40px;
        line-height: 48px;
        font-weight: 500;
        color: #292929;
      }
      .t2 {
        margin-top: 20px;
        line-height: 40px;
        font-size: 26px;
        color: #51565d;
      }
    }
    .img-box {
      width: 495px;
      height: 600px;
      margin: 50px auto;
      .img {
        width: 100%;
        height: 100%;
      }
    }
    .txt {
      text-align: center;
      font-size: 30px;
      line-height: 38px;
      color: #51565d;
    }
    .txt1 {
      margin: 24px 0;
    }
  }
  .marketing {
    padding: 64px 56px 88px;
    background: linear-gradient(
      180deg,
      #f8faff 0%,
      rgba(248, 250, 255, 0) 100%
    );
    .text {
      text-align: center;
      .t1 {
        font-size: 40px;
        line-height: 58px;
        font-weight: 500;
        color: #292929;
      }
      .t2 {
        margin-top: 20px;
        line-height: 40px;
        font-size: 26px;
        color: #51565d;
      }
    }
    .img-box-list {
      margin-top: 50px;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
    }
    .img-item {
      width: 159px;
      height: 164px;
      // box-shadow: inset 3px 2px 16px rgba(68, 93, 127, 0.1);
      border-radius: 10px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      margin-bottom: 24px;
      .img-box {
        width: 64px;
        height: 64px;
        margin-bottom: 16px;
        .img {
          width: 100%;
          height: 100%;
        }
      }
      .txt {
        font-size: 26px;
        color: #51565d;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/h5/goBeiH5.vue